import type { FC } from "react";
import { Link } from "react-router-dom";
import { Icon } from "../common/Icon";
import "./ReconnectBanner.css";

type ReconnectBannerProps = {
	title: string;
	description: string;
	actionLabel: string;
	to: string;
};

export const ReconnectBanner: FC<ReconnectBannerProps> = ({
	title,
	description,
	actionLabel,
	to,
}) => (
	<div className="reconnect-banner" role="alert">
		<div className="reconnect-banner__body">
			<span className="reconnect-banner__icon" aria-hidden="true">
				<Icon name="warning" size={20} fill />
			</span>
			<div className="reconnect-banner__copy">
				<p className="reconnect-banner__title">{title}</p>
				<p className="reconnect-banner__description">{description}</p>
			</div>
		</div>
		<Link to={to} className="reconnect-banner__action">
			{actionLabel}
			<Icon name="arrow_forward" size={16} />
		</Link>
	</div>
);
